import { Toaster, type ToasterProps } from 'sonner';
import { useTheme } from '../theme/ThemeProvider';

/**
 * sonner Toaster wired to ThemeProvider's preference. Drop-in for app roots.
 * Default props match what every ops-hub app wants: top-right, richColors,
 * theme follows the user's choice ('system' tracks OS).
 */
export function ThemedToaster(props: Omit<ToasterProps, 'theme'>) {
  const { preference } = useTheme();
  return (
    <Toaster
      theme={preference}
      richColors
      position="top-right"
      closeButton
      {...props}
    />
  );
}
